import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { IconDollarSign } from '../components/Icons';

const RentManagementView = () => {
  const { t } = useLanguage();
  
  const [rentStatus] = useState([
    {
      id: 1,
      propertyName: 'Makati Condo Unit 301',
      tenant: 'Juan Dela Cruz',
      monthlyRent: '₱45,000',
      status: 'paid',
      dueDate: '2024-01-25',
    },
    {
      id: 2,
      propertyName: 'BGC Apartment 201',
      tenant: 'Maria Santos',
      monthlyRent: '₱60,000',
      status: 'overdue',
      dueDate: '2024-01-15',
    },
    {
      id: 3,
      propertyName: 'Quezon City Townhouse 102',
      tenant: 'Jose Rizal',
      monthlyRent: '₱25,000',
      status: 'partiallyPaid',
      dueDate: '2024-01-20',
      paidAmount: '₱12,500',
    },
  ]);

  const getStatusBadge = (status) => {
    const statusConfig = {
      paid: { bg: 'bg-green-100', text: 'text-green-800', label: t('paid') },
      overdue: { bg: 'bg-red-100', text: 'text-red-800', label: t('overdue') },
      partiallyPaid: { bg: 'bg-yellow-100', text: 'text-yellow-800', label: t('partiallyPaid') },
    };

    const config = statusConfig[status];
    return (
      <span className={`px-2 py-1 text-xs font-semibold rounded-full ${config.bg} ${config.text}`}>
        {config.label}
      </span>
    );
  };

  const totalDeposit = '₱1,500,000';
  const depositProperties = 3;

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-8">{t('rentManagement')}</h1>

      {/* Rent Status */}
      <div className="bg-white rounded-lg shadow-md p-6 mb-8">
        <h2 className="text-xl font-semibold mb-4 flex items-center">
          <IconDollarSign className="w-6 h-6 mr-2" />
          {t('rentStatus')}
        </h2>
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {t('propertyName')}
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Tenant
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {t('monthlyRent')}
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Due Date
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {t('status')}
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {t('actions')}
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {rentStatus.map((rent) => (
                <tr key={rent.id}>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                    {rent.propertyName}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {rent.tenant}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {rent.monthlyRent}
                    {rent.status === 'partiallyPaid' && (
                      <div className="text-xs text-gray-500">
                        Paid: {rent.paidAmount}
                      </div>
                    )}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {rent.dueDate}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {getStatusBadge(rent.status)}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                    <button className="text-blue-600 hover:text-blue-900">
                      {t('setupAutoCharge')}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Deposit Management */}
      <div className="bg-white rounded-lg shadow-md p-6">
        <h2 className="text-xl font-semibold mb-4">{t('depositManagement')}</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-gray-50 rounded-lg p-4">
            <p className="text-sm text-gray-600 mb-1">{t('totalDeposit')}</p>
            <p className="text-2xl font-bold text-gray-900">{totalDeposit}</p>
            <p className="text-sm text-gray-500 mt-1">{depositProperties} {t('properties')}</p>
          </div>
          <div className="flex items-center justify-center">
            <button className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-md">
              {t('viewSettlementHistory')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RentManagementView;
